import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";

import AboutYou from "./AboutYou";
import {
  doVerifyInstntDocument,
  doSubmitVerify,
} from "./Actions/AboutYouActions";

class AboutYouContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newMember: false,
    };
  }

  componentDidMount() {
    const {
      applicantData,
      applicationCompleteList,
      inSessionJointApplicant,
    } = this.props;
    const tempHide = sessionStorage.getItem("TEMP_HIDE");
    console.log(
      "componentDidMount",
      applicantData?.acquireType,
      applicationCompleteList.length,
      tempHide,
      inSessionJointApplicant
    );
    if (
      applicantData?.acquireType !== "search" ||
      !applicationCompleteList ||
      tempHide === "false" ||
      !inSessionJointApplicant
    ) {
      this.setState({
        newMember: true,
      });
    }
  }

  render() {
    const { newMember } = this.state;
    const {
      doVerifyDocument,
      formData,
      doSubmitDocVerify,
      getDataFromServer,
      continuehandler,
      isEdit,
      handleBack,
      scanDocument,
      steps,
      activeStepID,
      vaultProductList,
      getActiveProduct,
    } = this.props;

    return (
      <AboutYou
        doSubmitDocVerify={doSubmitDocVerify}
        verifyDoc={doVerifyDocument}
        formData={formData}
        isInEditFlow={isEdit}
        getDataFromServer={getDataFromServer}
        continuehandler={continuehandler}
        handleBack={handleBack}
        scanDocument={scanDocument}
        steps={steps}
        activeStepID={activeStepID}
        vaultProductList={vaultProductList}
        getActiveProduct={getActiveProduct}
        newMember={newMember}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.AboutYouReducer.formData,
  updateApplicant: state.ComplianceReducer,
  isEdit: state.ApplicationReducer.isEdit,
  scanDocument: state.ApplicationReducer.scanDocument,
  vaultProductList: state.VaultReducer.vaultProductList,
  applicantData: state.ApplicationReducer.response,
  applicationCompleteList: state.ApplicationReducer.applicationCompleteList,
  inSessionJointApplicant: state.JoinApplicantReducer.inSessionJointApplicant,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doVerifyDocument: (documentData, callback) =>
      dispatch(doVerifyInstntDocument(documentData, callback)),
    doSubmitDocVerify: (submitData, callback) =>
      dispatch(doSubmitVerify(submitData, callback)),
  };
};

AboutYouContainer.propTypes = {
  doVerifyDocument: PropTypes.func,
  doSubmitDocVerify: PropTypes.func.isRequired,
  formData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  isEdit: PropTypes.bool,
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  scanDocument: PropTypes.bool.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  vaultProductList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]),
  getActiveProduct: PropTypes.func,
};

AboutYouContainer.defaultProps = {
  doVerifyDocument: () => {},
  formData: null,
  isEdit: false,
  steps: [],
  activeStepID: -1,
  vaultProductList: [],
  getActiveProduct: () => {},
};

const AboutYouWrapper = withApplicantHOC(AboutYouContainer);

export default connect(mapStateToProps, mapDispatchToProps)(AboutYouWrapper);
